<template>
  <div
    v-if="modalIsOpened"
    id="teamInfoModal"
    class="fixed inset-0 w-full bg-black/30 z-51"
  >
    <div
      class="fixed inset-0 overflow-y-auto flex items-start justify-center py-8"
      @click.self="closeModal"
    >
      <div class="w-[100vw] max-w-[450px] px-[20px] overflow-hidden m-auto">
        <!-- actual modal -->
        <div
          class="mx-auto box-effect rounded-[10px] bg-white overflow-hidden max-w-[450px]"
        >
          <div
            class="flex flex-col justify-center items-start gap-[22px] py-[12px] px-[20px]"
          >
            <div class="w-full flex flex-col items-center relative">
              <WorkFlowChartIcon class="w-[50px] h-[50px] text-primary" />
              <span class="PC_Body1-SB !text-primary-dark">ข้อมูล</span>
              <span class="PC_caption-R text-primary-dark">
                {{ name }}
              </span>
              <div
                class="absolute right-0 border border-grey-light rounded-md w-9 h-9 flex items-center justify-center cursor-pointer"
                @click="closeModal"
              >
                <CloseIcon class="w-9 text-primary" />
              </div>
            </div>
            <div
              class="w-full max-h-[469px] min-h-[469px] flex flex-col items-start gap-[12px] overflow-auto"
              :class="{ 'pr-[22px]': item.length > 0 }"
            >
              <div
                v-for="(data, index) in item"
                :key="index"
                class="w-full flex items-center justify-between gap-[12px]"
              >
                <div class="flex items-center">
                  <span class="min-w-[20px] text-primary-dark">
                    {{ ++index }}
                  </span>
                  <div class="flex items-center gap-[10px]">
                    <div
                      class="min-w-[30px] w-[30px] h-[30px] border-[1px] border-solid border-[#F2E7F9] rounded-full overflow-hidden flex items-center justify-center"
                    >
                      <img
                        :src="
                          data.default_image
                            ? useUsersStore().defaultImg
                            : data.image
                        "
                        class="object-cover"
                        :class="data.default_image ? 'w-6 h-6' : 'w-full'"
                        alt=""
                      />
                    </div>
                    <div class="flex flex-col">
                      <span class="PC_Body2-R text-primary-dark">
                        {{
                          `${data.prefix_name} ${data.firstname} ${data.lastname}` ||
                          "-"
                        }}
                      </span>
                    </div>
                  </div>
                </div>
                <div>
                  <ButtonComponent
                    :icon="'InfoIcon'"
                    :bClass="'btn_shadow--2'"
                    :iClass="'w-[24px] h-[24px] p-[2px]'"
                    @clicked="() => memberInfo(data)"
                  />
                </div>
              </div>
              <div
                v-if="item.length <= 0"
                class="PC_Body1-R text-[#7C7379] text-center mx-auto mt-[40px]"
              >
                ขณะนี้ยังไม่มีข้อมูล
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useUsersStore } from "@/pinia/users";
import { useTeamStore } from "@/pinia/team";
// import { storeToRefs } from "pinia";
import axios from "axios";

const props = defineProps({
  EditAndDelete: {
    type: Boolean,
    default: true,
  },
});

const teamStore = useTeamStore();
const emit = defineEmits(["success", "info", "edit", "warning"]);

const item = ref({});
const name = ref("");
const modalIsOpened = ref(false);

const openModal = (data, dataName) => {
  modalIsOpened.value = true;
  document.body.style.overflow = "hidden";
  item.value = data;
  console.log("dataName", dataName);

  name.value = dataName;
  console.log("name.value", name.value);
};

const closeModal = () => {
  modalIsOpened.value = false;
  document.body.style.overflow = "auto";
};

const memberInfo = async (data) => {
  emit("info", data);
};

const warnDeletion = async () => {
  await axios
    .get(`/team/${item.value.id}/check-appointment`)
    .then((res) => {
      console.log(res);
      if (res.status === 200) {
        emit("warning", res.data.message, item.value.id);
      }
    })
    .catch((err) => {
      emit("error", err.response.data.message);
    });
};

defineExpose({ openModal, closeModal });
</script>

<style lang="scss" scoped>
</style>